import React, { useState } from 'react';
import { toast } from 'sonner';
import { Pencil, Check, X } from 'lucide-react';
import { api, errMsg } from './briefApi';

export const markupLabel = (m) => (m > 0 ? `${m}×` : 'Pass-through (0)');

export const MarkupField = ({ briefId, value, onSaved }) => {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState('');
  const [busy, setBusy] = useState(false);

  const start = () => { setDraft(String(value)); setEditing(true); };
  const save = async () => {
    const n = Number(draft);
    if (draft.trim() === '' || !Number.isFinite(n) || n < 0) { toast.error('Enter a number of 0 or more (0 = pass-through)'); return; }
    setBusy(true);
    try {
      const d = await api.patch(`/${briefId}/markup`, { client_markup: n });
      toast.success(`Markup set to ${markupLabel(d.client_markup)}`, { description: 'Click Export Client to update the client sheet.' });
      onSaved(d.client_markup);
      setEditing(false);
    } catch (e) {
      toast.error(errMsg(e, 'Could not update markup'));
    } finally {
      setBusy(false);
    }
  };

  if (!editing) {
    return (
      <button onClick={start} title="Client price = creator cost × markup (0 = pass-through)" className="rounded-full px-3 py-2 text-xs font-medium inline-flex items-center gap-1.5 border border-dashed border-black/[0.2] dark:border-white/20 text-[#0F0F0F] dark:text-white hover:border-[#FF451A]/60 hover:text-[#FF451A] transition-colors" data-testid="brief-markup-display">
        Markup: <span className="font-bold font-mono" data-testid="brief-markup-value">{markupLabel(value)}</span> <Pencil size={11} />
      </button>
    );
  }
  return (
    <div className="inline-flex items-center gap-1 rounded-full border border-[#FF451A]/60 pl-3 pr-1 py-1 bg-white dark:bg-[#1A1D24]" data-testid="brief-markup-editor">
      <span className="text-xs text-[#6B6B6B] dark:text-zinc-400">Markup</span>
      <input
        autoFocus
        type="text"
        inputMode="decimal"
        value={draft}
        onChange={(e) => setDraft(e.target.value)}
        onKeyDown={(e) => { if (e.key === 'Enter') save(); if (e.key === 'Escape') setEditing(false); }}
        className="w-16 bg-transparent text-xs font-mono font-bold text-[#0F0F0F] dark:text-white outline-none"
        data-testid="brief-markup-input"
      />
      <span className="text-xs text-[#6B6B6B]">×</span>
      <button onClick={save} disabled={busy} className="rounded-full p-1 text-emerald-600 hover:bg-emerald-500/10" data-testid="brief-markup-save"><Check size={12} /></button>
      <button onClick={() => setEditing(false)} className="rounded-full p-1 text-[#6B6B6B] hover:bg-black/5 dark:hover:bg-white/10" data-testid="brief-markup-cancel"><X size={12} /></button>
    </div>
  );
};
